import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { get, isEmpty, chunk } from "lodash"

import { Panel } from "components/organisms/panel"
import { BaseTable } from "components/molecules/table"
import { SpDetailTable } from "components/molecules/table/spTable"
import { tableColumns } from "config/table_columns"
import { BaseSelect } from "components/atoms/input/select"
import { Sort } from "utils/sort"
import { indicatorListApi } from "components/actions/indicatorList"
import IndicatorChartComponent from "components/molecules/chart/indicatorChart"
import {
  indicatorChartSymbol,
  spIndicatorChartSymbol,
} from "redux/ducks/IndicatorChart"
import { useIndicatorChartInitialize } from "components/atoms/chart/parts/useChartInitialize"
import { Pagination } from "components/molecules/pagination"
import { PAGE_NUM, ROUTE_LIST } from "config/const"
import { NewsList } from "components/organisms/panel/newsList"
import { checkIsSp } from "utils/util"
import { MainContainer } from "components/molecules/utils/mainContainer"

type Props = {
  indicationList: Array<object>
  changeIndicationList: Function
  transitionData: object
  setTransitionData: Function
  setRefreshFlag?: Function
}

export const EconomicsTemplate = (props: Props) => {
  const [currentPosition, changePosition] = useState<number>(0)
  const [currentPage, changePage] = useState<number>(0)
  const [checkTransitionData, setCheckTransitionData] = useState(false)
  const [newsEffect, setNewsEffect] = useState(false)
  const indicationList = get(props.indicationList, "apiRes")
  const selectMonthNum = get(props.indicationList, "selectMonthNum")
  const displayPeriodNum = get(props.indicationList, "displayPeriodNum")
  const industryNum = get(props.indicationList, "industryNum")
  const list: Array<Array<object>> = chunk(indicationList, PAGE_NUM.PAGE_10)
  const isPhone = checkIsSp()

  const canvasId = useIndicatorChartInitialize()
  const dispatch = useDispatch()

  useEffect(() => {
    // チャートのdefalut表示(先頭のデータ)
    if (isEmpty(indicationList)) return
    if (isEmpty(props.transitionData) || checkTransitionData) {
      dispatch(indicatorChartSymbol(canvasId, indicationList[0]))
    } else {
      dispatch(
        indicatorChartSymbol(canvasId, get(props.transitionData, "data"))
      )
      changePosition(get(props.transitionData, "activePosition"))
      changePage(get(props.transitionData, "currentPage"))
      setCheckTransitionData(true)
    }
  }, [indicationList, props.transitionData])

  useEffect(() => {
    if (isEmpty(list)) return
    const currentPageList = list[currentPage]
    dispatch(indicatorChartSymbol(canvasId, currentPageList[currentPosition]))
  }, [currentPage])

  return (
    <MainContainer className="symmetry-layout">
      <div className="contents-block">
        <Panel
          title=""
          className="summary-index-panel panel-economic-indicator"
          // refresh={() => {
          //   props.setRefreshFlag(true)
          //   setNewsEffect(true)
          // }}
          filter={
            <div className="control-row  sp">
              <BaseSelect
                option={Sort.EconomicDate}
                value={displayPeriodNum}
                onChange={(num: number) => {
                  changePosition(0)
                  changePage(0)
                  setNewsEffect(true)
                  indicatorListApi({
                    displayPeriodNum: num,
                    selectMonthNum: 0,
                    industryNum: industryNum,
                    apiParam: Sort.EconomicDate[num].apiCall,
                    changeIndicatorList: props.changeIndicationList,
                  })
                }}
              />
              {displayPeriodNum === 4 && (
                <BaseSelect
                  option={Sort.EconomicMonth}
                  value={selectMonthNum}
                  onChange={(num: number) => {
                    setNewsEffect(true)
                    indicatorListApi({
                      displayPeriodNum: displayPeriodNum,
                      selectMonthNum: num,
                      industryNum: industryNum,
                      apiParam: Sort.EconomicMonth[num].apiCall,
                      changeIndicatorList: props.changeIndicationList,
                    })
                  }}
                />
              )}
              {displayPeriodNum === 5 && (
                <BaseSelect
                  option={Sort.EconomicDateSortByIndustry}
                  value={industryNum}
                  onChange={(num: number) => {
                    setNewsEffect(true)
                    indicatorListApi({
                      displayPeriodNum: displayPeriodNum,
                      selectMonthNum: selectMonthNum,
                      industryNum: num,
                      apiParam: Sort.EconomicDateSortByIndustry[num].apiCall,
                      changeIndicatorList: props.changeIndicationList,
                    })
                  }}
                />
              )}
            </div>
          }
        >
          <div className="result-list-block">
            {!isPhone ? (
              <>
                <BaseTable
                  className="table-list-view table-liquid-cell table-economic-indicator"
                  list={tableColumns.economics.index}
                  data={list[currentPage]}
                  active={currentPosition}
                  onClick={(data: object, i: number) => {
                    dispatch(indicatorChartSymbol(canvasId, data))
                    changePosition(i)
                    setNewsEffect(true)
                  }}
                />
                <Pagination
                  list={indicationList}
                  current={currentPage}
                  page={PAGE_NUM.PAGE_10}
                  changePage={(num: number) => {
                    changePosition(0)
                    changePage(num)
                  }}
                />
              </>
            ) : (
              <SpDetailTable
                headerList={tableColumns.economics.sp.header}
                bodyList={tableColumns.economics.sp.body}
                data={indicationList}
                onClick={(data: object) => {
                  dispatch(spIndicatorChartSymbol(data))
                }}
              />
            )}
          </div>
        </Panel>
      </div>
      <div className="contents-block">
        <div className="contents-nest-block">
          {!isPhone && (
            <Panel
              className="panel-list panel-economic-indicator-chart"
              title=""
              nonePanelHeader={true}
            >
              <IndicatorChartComponent canvasId={canvasId} />
            </Panel>
          )}
          <NewsList
            route={ROUTE_LIST.TOP_ECONOMICS}
            effect={newsEffect}
            setEffect={setNewsEffect}
          />
        </div>
      </div>
    </MainContainer>
  )
}
